export const CommunitiesRoutes = {
  Communities: 'Communities',
  CommunitiesHome: 'CommunitiesHome',
  Room: 'Room',
  RoomView: 'RoomView',
  AddMessageModal: 'AddMessageModal',
  Thread: 'Thread',
  Members: 'Members',
  MemberProfile: 'MemberProfile',
  Reply: 'Reply',
  QuestionsList: 'QuestionsList',
  AddQuestionModal: 'AddQuestionModal',
  SketchesList: 'SketchesList',
  AddSketchModal: 'AddSketchModal'
} as const

export const RoomRoutes = {
  Room: 'Room',
  RoomMembers: 'RoomMembers',
  RoomThread: 'RoomThread',
  RoomNewMessage: 'RoomNewMessage',
  RoomReply: 'RoomReply',
  RoomQuestionList: 'RoomQuestionList',
  RoomNewQuestion: 'RoomNewQuestion',
  RoomSketchList: 'RoomSketchList',
  RoomNewSketch: 'RoomNewSketch'
} as const

export const CommunitiesRoomRoutes = {
  CommunitiesRoom: 'CommunitiesRoom',
  CommunitiesRoomMembers: 'CommunitiesRoomMembers',
  CommunitiesRoomThread: 'CommunitiesRoomThread',
  CommunitiesRoomNewMessage: 'CommunitiesRoomNewMessage',
  CommunitiesRoomReply: 'CommunitiesRoomReply',
  CommunitiesRoomQuestionList: 'CommunitiesRoomQuestionList',
  CommunitiesRoomNewQuestion: 'CommunitiesRoomNewQuestion',
  CommunitiesRoomSketchList: 'CommunitiesRoomSketchList',
  CommunitiesRoomNewSketch: 'CommunitiesRoomNewSketch'
} as const

// Inventory Tabnav
export const WalletRoutes = {
  NFTs: 'NFTs',
  Coins: 'Coins'
} as const

// Spaces Tabnav
export const SpacesRoutes = {
  Spaces: 'Spaces',
  People: 'People'
} as const

// Home Tabnav
export const TabRoutes = {
  Home: 'Home',
  Wallet: 'Wallet',
  Map: 'Map',
  MapAr: 'MapAr',
  Connect: 'Connect',
  Space: 'Space',
  Coins: 'Coins',
  People: 'People'
} as const

// App Stack
export const AppRoutes = {
  Claim: 'Claim',
  connect: 'connect',
  businessConnect: 'businessConnect',
  NFTDetail: 'NFTDetail',
  NFTSellDetail: 'NFTSellDetail',
  updateProfile: 'updateProfile',
  home: 'home',
  settingsMetamask: 'settingsMetamask',
  editProfile: 'editProfile',
  manageAccounts: 'manageAccounts',
  // profileOther:'profileOther',
  profileUser: 'profileUser',
  profileOtherUser: 'profileOtherUser',
  profileOtherUser_Business: 'profileOtherUser_Business',
  MemberProfile: 'MemberProfile',
  sendConfirmation: 'sendConfirmation',
  followPeople: 'followPeople',
  invitePeople: 'invitePeople',
  sendToChainConfirmation: 'sendToChainConfirmation',
  Acquire: 'Acquire',
  Acquire_Business: 'Acquire_Business',
  AcquirePubVariation: 'AcquirePubVariation',
  AcquirePubVariation1: 'AcquirePubVariation1',
  AcquirePubVariation2: 'AcquirePubVariation2',
  nftFilters: 'nftFilters',
  CameraScreen: 'CameraScreen',
  MintSuccess: 'MintSuccess',
  MapAR: 'MapAR',
  TokenAR: 'TokenAR',
  LogoutCallback: 'LogoutCallback',
  HelloWorld: 'HelloWorld',
  LoginCallback: 'LoginCallback',
  BusinessNFTDetail: 'BusinessNFTDetail',
  coin: 'coin',
  CoinDetail_Business: 'CoinDetail_Business',
  NFTDetail_Business: 'NFTDetail_Business',
  BusinessProxy: 'BusinessProxy',
  ARGame: 'ARGame',
  Redirect: 'Redirect',
  followList: 'followList',
  Metaverse: 'Metaverse',
  ...RoomRoutes,
  ...CommunitiesRoomRoutes
} as const
